import { AppMode } from './app-mode';

interface AppModeOptions {
    name: string;
    mode: AppMode;
}

export const appModeOptions: AppModeOptions[] = [
    {
        name: 'GENERAL.TITLE.MULTIUSER',
        mode: 'multi-user',
    },
    {
        name: 'GENERAL.TITLE.PERSONAL',
        mode: 'personal',
    },
];

export function getAppModeOptionName(mode: AppMode) {
    return appModeOptions.find((appModeOptions) => appModeOptions.mode === mode)!.name;
}
